import Row from '@sdk/components/ui/spacing/Row';
import Text11 from '@sdk/components/ui/typography/Text11';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { ValidationResults } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import {
  LabelSection,
  ContentSection,
} from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';

type Props = {
  submitErrors: ValidationResults;
  timeClockEntryKey: string;
};
const TimeClockSectionErrors = ({ submitErrors, timeClockEntryKey }: Props) => {
  if (!submitErrors) {
    return null;
  }

  const timeClockEntryError = submitErrors.timeClock?.[timeClockEntryKey];
  const breaksErrors = submitErrors.breaks?.[timeClockEntryKey];

  if (!timeClockEntryError && !breaksErrors) {
    return null;
  }

  let message = timeClockEntryError || '';
  if (!message) {
    const badBreakFieldIds = Object.keys(breaksErrors);
    message =
      badBreakFieldIds.length > 1
        ? gettext('Multiple break errors, please check on the entries')
        : breaksErrors[badBreakFieldIds[0]];
  }

  return (
    <Row mBottom={10} mTop={10}>
      <LabelSection />
      <ContentSection>
        <Text11 bold themeColor={ThemeColorType.danger}>
          {message}
        </Text11>
      </ContentSection>
    </Row>
  );
};

export default TimeClockSectionErrors;
